import React, { memo } from "react";
import PropTypes from "prop-types";
import { StyledSideElement } from "./Side.styles";

const Side = memo(({ children, isHome = false, orientation }) => {
  // Always show immediately as a fixed element
  return (
    <StyledSideElement $orientation={orientation}>
      {children}
    </StyledSideElement>
  );
});

Side.propTypes = {
  children: PropTypes.node.isRequired,
  isHome: PropTypes.bool,
  orientation: PropTypes.oneOf(["left", "right"]),
};

Side.displayName = "Side";

export default Side;
